<template>
  <div class="repos" >
    <div class="list">
      <List/>
    </div>
    <div class="detail">
      <Detail ref="detail"/>
    </div>
  </div>
</template>

<script>
import List from './StarsPanel'
import Detail from './Detail'

export default {
  components: {
    List,
    Detail,
  },
  mounted() {
    this.$on('refresh', () => {
      this.$refs.detail.$emit('refresh')
    })
  },
}
</script>
<style lang="scss" scoped>
.repos{
  display: flex;
  .list{
    width: 340px;
    flex-shrink: 0;
  }
  .detail{
    flex: 1 1 auto;
  }
}
</style>
